import { createAction } from "redux-actions";

export const SHIPPING_LIST = "SHIPPING_LIST";
export const shippingList = createAction(SHIPPING_LIST);

export const SHIPPING_DETAILS = "SHIPPING_DETAILS";
export const shippingDetails = createAction(SHIPPING_DETAILS);

export const ADD_SHIPPING = "ADD_SHIPPING";
export const addShipping = createAction(ADD_SHIPPING);

export const UPDATE_SHIPPING = "UPDATE_SHIPPING";
export const updateShipping = createAction(UPDATE_SHIPPING);

export const DELETE_SHIPPING = "DELETE_SHIPPING";
export const deleteShipping = createAction(DELETE_SHIPPING);
